import Phaser from 'phaser';

export interface PhaserGameLifecycle {
	destroy: (game: Phaser.Game) => void;
	waitForPendingDestroy: () => Promise<void>;
}

function releaseWebGlContext(game: Phaser.Game): void {
	if (game.renderer.type !== Phaser.WEBGL) {
		return;
	}

	const renderer = game.renderer as Phaser.Renderer.WebGL.WebGLRenderer;
	const loseContext = renderer.gl?.getExtension('WEBGL_lose_context');

	loseContext?.loseContext();
}

export function createPhaserGameLifecycle(): PhaserGameLifecycle {
	let pendingDestroy: Promise<void> | null = null;

	return {
		destroy(game) {
			let resolveDestroy: () => void = () => undefined;
			const destroyPromise = new Promise<void>((resolve) => {
				resolveDestroy = resolve;
			});

			pendingDestroy = destroyPromise;
			game.events.once(Phaser.Core.Events.DESTROY, () => {
				if (pendingDestroy === destroyPromise) {
					pendingDestroy = null;
				}
				resolveDestroy();
			});

			releaseWebGlContext(game);
			game.destroy(true);
		},
		async waitForPendingDestroy() {
			if (pendingDestroy) {
				await pendingDestroy;
			}
		},
	};
}
